document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("poolSliderTrack");
  const slides = Array.from(document.querySelectorAll(".pool-slider--slide"));
  const dots = document.querySelectorAll(".pool-slider--dot");
  const prev = document.querySelector(".pool-slider--nav.prev");
  const next = document.querySelector(".pool-slider--nav.next");
  let currentIndex = 1; // Start at first real slide (after clone)
  let isTransitioning = false;
 
  // Clone first and last slides for infinite loop
  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slides.length - 1].cloneNode(true);
  track.appendChild(firstClone);
  track.insertBefore(lastClone, slides[0]);
 
  // Update slides array to include clones
  const allSlides = Array.from(document.querySelectorAll(".pool-slider--slide"));
  // Set initial position
  track.style.transform = `translateX(-${currentIndex * 100}%)`;
 
  function updateDots(index) {
    const realIndex = index % slides.length;
    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[realIndex]) dots[realIndex].classList.add("active");
  }
 
  function moveToSlide(index, withTransition = true) {
    if (isTransitioning) return;
    isTransitioning = true;
 
    track.style.transition = withTransition ? "transform 0.5s ease" : "none";
    track.style.transform = `translateX(-${index * 100}%)`;
    currentIndex = index;
 
    // Handle loop reset
    setTimeout(() => {
      if (currentIndex === allSlides.length - 1) {
        track.style.transition = "none";
        currentIndex = 1;
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      } else if (currentIndex === 0) {
        track.style.transition = "none";
        currentIndex = allSlides.length - 2;
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      }
      updateDots(currentIndex - 1); // Adjust for clones
      isTransitioning = false;
    }, withTransition ? 500 : 0);
  }
 
  next.addEventListener("click", () => {
    moveToSlide(currentIndex + 1);
  });
 
  prev.addEventListener("click", () => {
    moveToSlide(currentIndex - 1);
  });
 
  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      const i = parseInt(dot.getAttribute("data-slide"));
      moveToSlide(i + 1); // Adjust for clone
    });
  });
 
  window.addEventListener("resize", () => {
    track.style.transition = "none";
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
  });
 
  updateDots(currentIndex - 1); // Initial dot state
});
